<script>
	window.location.replace('https://ds-advance.pages.dev');
</script>

<main>
	<h1>Redirecting...</h1>
	<h3>Tasks has become Advance - click the link below if you aren't automatically redirected.</h3>
	<a href="https://ds-advance.pages.dev">Advance</a>
</main>

<style>
	main {
		text-align: center;
		padding: 1em;
		margin: 0 auto;
	}

	h1 {
		color: #ff3e00;
		font-size: 4em;
		font-weight: 100;
	}
</style>